import { render } from "./educationalOffline.vue?vue&type=template&id=00f33fb3&scoped=true"
import script from "./educationalOffline.vue?vue&type=script&lang=js"
export * from "./educationalOffline.vue?vue&type=script&lang=js"

import "./educationalOffline.vue?vue&type=style&index=0&id=00f33fb3&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00f33fb3"]])

export default __exports__